import {fetch} from '../../utils/dataAccess';

export default async function createReceipt(orderIri, retailerIri, value) {
    const response = await fetch('/receipts', {
        method: 'POST',
        body: JSON.stringify({order: orderIri, retailer: retailerIri, value}),
        headers: new Headers({'Content-Type': 'application/ld+json'}),
    });
    return await response.json();
}
